import PrerateAdditionalInfoModalContentContainer from './PrerateAdditionalInfoModalContentContainer';

export default PrerateAdditionalInfoModalContentContainer;
